"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cases = void 0;

var _when = require("../when/when");

var _i2 = require("../i/i");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Functional case statement.
 *
 * @name cases
 * @tag Core
 * @see {@link when}
 *
 * @param {[ifFn, thenFn][]} conditions  List of 2-tuples of functions (if, then)
 * @param {Function}         otherwise   Function to call if no condition matches
 *                                       Defaults to identity.
 * @param {any}              source      Value to check
 *
 * @returns {any}
 * The result of calling the first matching then function or the
 * otherwise function on the input.
 *
 *
 * @example
 * cases([
 *  [x === 0, x => x * 2],
 *  [x === 1, x => x],
 * ], x => x + 1)(2)
 * // => 3
 */
var cases = function cases(_ref) {
  var _ref2 = _toArray(_ref),
      _ref2$ = _slicedToArray(_ref2[0], 2),
      conditionFn = _ref2$[0],
      thenFn = _ref2$[1],
      rest = _ref2.slice(1);

  var otherwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _i2.i;
  return (0, _when.when)(conditionFn, thenFn, rest.length === 0 ? otherwise : cases(rest, otherwise));
};

exports.cases = cases;